import { addMutator } from '@poa/state';
import {
  fetchById,
  fetchByIdFailed,
  fetchByIdSuccess,
  setDates,
  setChartType
} from './shared-links.actions';
import moment from 'moment';
import { CHART_TYPE } from './shared-links.constants';


// fetch by id
addMutator(fetchById, (payload, { store }) => {
  store.shareLinks.meta.isLoading = true;
  store.shareLinks.meta.hasError = false;
});


addMutator(fetchByIdSuccess, ({ data, _meta }, { store }) => {
  store.shareLinks.meta.isLoading = false;
  store.shareLinks.meta.hasError = false;
  
  store.shareLinks.data = data.account;
  store.shareLinks.payments = data.payments;
  store.shareLinks.rawPayments = data.payments;
  store.shareLinks.claimsQty = data.account.claimes_qty;
  store.shareLinks.revenue = data.account.revenue;

  store.shareLinks.filters.startDate = moment(data.startDate, 'DD.MM.YYYY HH:mm');
  store.shareLinks.filters.endDate = moment(data.endDate, 'DD.MM.YYYY HH:mm');

  store.shareLinks.meta.loaded = true;
});


addMutator(fetchByIdFailed, (payload, { store }) => {
  store.shareLinks.meta.isLoading = false;
  store.shareLinks.meta.hasError = true;
});


addMutator(setDates, ({ startDate, endDate }, { store }) => {

  if (startDate) {
    store.shareLinks.filters.startDate = moment(startDate);
  }

  if (endDate) {
    store.shareLinks.filters.endDate = moment(endDate);
  } else {
    store.shareLinks.filters.endDate = moment();
  }
});


addMutator(setChartType, ({ chartType }, { store }) => {

  let startDate = store.shareLinks.filters.startDate;
  let endDate = store.shareLinks.filters.endDate;

  switch (chartType) {

    case CHART_TYPE.EARNINGS:

      store.shareLinks.payments.earnings = store.shareLinks.rawPayments.earnings.filter(
        item => moment(item.date, "DD.MM.YYYY").isBetween(startDate, endDate)
      )

      store.shareLinks.revenue = store.shareLinks.payments.earnings.reduce((acc, item) => acc + item.total, 0);
      break;

    case CHART_TYPE.SUBS:
      store.shareLinks.payments.fans = store.shareLinks.rawPayments.fans.filter(
        item => moment(item.date, "DD.MM.YYYY").isBetween(startDate, endDate)
      )

      store.shareLinks.claimsQty = store.shareLinks.payments.fans.reduce((acc, item) => acc + item.total, 0);
      break;

    case CHART_TYPE.CUMULATIVE_ERANINGS:
      let cumulativeTotal = 0;
      let filteredEarnings = store.shareLinks.rawPayments.earnings.filter(
        item => moment(item.date, "DD.MM.YYYY").isBetween(startDate, endDate)
      )
      
      store.shareLinks.payments.earnings = filteredEarnings.map(item => {
        if (moment(item.date, "DD.MM.YYYY").isBetween(startDate, endDate)) {
          cumulativeTotal += item.total;
        }
        return { ...item, total: cumulativeTotal };
      });
      store.shareLinks.revenue = cumulativeTotal

      break;

    case CHART_TYPE.CUMULATIVE_SUBS:
      let cumulativeFansTotal = 0;

      let filteredFans = store.shareLinks.rawPayments.fans.filter(
        item => moment(item.date, "DD.MM.YYYY").isBetween(startDate, endDate)
      )

      store.shareLinks.payments.fans = filteredFans.map(item => {
        if (moment(item.date, "DD.MM.YYYY").isBetween(startDate, endDate)) {
          cumulativeFansTotal += item.total;
        }
        return { ...item, total: cumulativeFansTotal };
      });

      store.shareLinks.claimsQty = cumulativeFansTotal
      break;
    default:
      store.shareLinks.payments = store.shareLinks.rawPayments.earnings;
  }
}
);